module.exports = require("humanize-duration");